import { Observable } from 'rxjs';
import { CardAnalyticsQuery, UserSnapshotResponse, UserDistributionResponse, UserTrendsResponse, UserGeoResponse } from './user-analytics.model';

export abstract class UserAnalyticsService {
    abstract getSnapshot(): Observable<UserSnapshotResponse>;
    abstract getDistribution(query?: CardAnalyticsQuery): Observable<UserDistributionResponse>;
    abstract getTrends(query?: CardAnalyticsQuery): Observable<UserTrendsResponse>;
    abstract getGeo(): Observable<UserGeoResponse>;
}
